//vue实例
import vueMain from '@/main.js'

export function setTime(date,type,dateType = '-',timeType = ':') {
    let newDate
    if(date) {
        newDate = new Date(date)
    }else {
        newDate = new Date()
    }

    var year = newDate.getFullYear();
    var month = newDate.getMonth() + 1;
    var dates = newDate.getDate();
    var h = newDate.getHours();
    h = h < 10 ? '0' + h : h;
    var m = newDate.getMinutes();
    m = m < 10 ? '0' + m : m;
    var s = newDate.getSeconds();
    s = s < 10 ? '0' + s : s;

    if(type == 'date') {
        return `${year}${dateType}${month}${dateType}${dates}`
    }else if(type == 'time') {
        return `${h}${timeType}${m}${timeType}${s}`
    }else {
        return `${year}${dateType}${month}${dateType}${dates + ' '}${h}${timeType}${m}${timeType}${s}`
    }

}

// 防抖函数
export function buttonClick(func, time) {
    //这里必须在 函数外部进行 声明 否则 每一次执行是互不干扰。
    let timer
        //注意这里不能使用箭头函数  否则会改变this的指向
    return function() {
        let _this = this;
        // 清除 timer 延时方法
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.call(_this);
            // palyMoney 方法需要带参数 可以将call 改成 apply
            // func.call(_this,obj);
        }, time)
    }
}

// 获取页面曝光信息
export function getPageInformation () {
    if(vueMain.$route.meta){
        return {
            'data-page_name': vueMain.$route.meta.pageName,
            'data-page_url': location.href,
            'data-channel': vueMain.GLOBAL.isPC() ? 'PC' : 'H5'
        }
    }
}

// 埋点设置
export function buryPoint (type,params) {
    if(!type ) return
    console.log('触发埋点===>',type);
    switch (type) {
        //运营位点击
        case 'Banner_Click' : 
            vueMain.$buryPoint('Banner_Click',
            {
                banner_type:params.banner_type,
                banner_id:params.id,
                banner_name:params.name,
                url:params.jumpUrl || ''
            })
            break;
        //导航按钮点击
        case 'Navigat_Button_Click' :
            vueMain.$buryPoint('Navigat_Button_Click',{button_name:'主导航按钮'})
            break;
        //搜索按钮点击
        case 'Search_Button_Click' :
            vueMain.$buryPoint('Search_Button_Click')
            break;
        //提交搜索请求
        case 'Search_Submit' :
            vueMain.$buryPoint('Search_Submit',{search_keyword:params.search_keyword})
            break;
        //更多按钮点击
        case 'MoreButton_Click' :
            vueMain.$buryPoint('MoreButton_Click',{
                banner_area:'图片导航运营位',
                ...params
            })
            break;
        //按钮点击
        case 'Button_Click' :
            vueMain.$buryPoint('Button_Click',{
                ...params
            })
            break;
        //菜单点击
        case 'Menu_Click' :
            vueMain.$buryPoint('Menu_Click',{
                ...params
            })
            break;
        //产品点击
        case 'Product_Click' :
            vueMain.$buryPoint('Product_Click',{
                ...params
            })
            break;
    }
}

// 自动曝光设置

export function setExposure () {
    //自动曝光 页面浏览
    aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['aplus-auto-exp', [
            {
              // 需要曝光的元素class
              cssSelector: '.auto-exp-component', 
              //如果页面模块是元素内滚动（某个区块内有滚动条）则需要增加positionSelector辅助定位曝光元素
              // positionSelector: '.parent', 
              logkey: 'Page_View',  //事件管理中的事件id
              props: [
                        'data-page_name',
                        'data-page_url',
                        'data-channel',
                        'data-product_id',
                        'data-product_name',
                        'data-product_type',
                        'data-products_series'
                    ], // 你要曝光的元素身上自定义属性
            },
            {
                // 需要曝光的元素class
                cssSelector: '.banner-exp-component', 
                //如果页面模块是元素内滚动（某个区块内有滚动条）则需要增加positionSelector辅助定位曝光元素
                // positionSelector: '.parent', 
                logkey: 'Banner_Exposure',  //事件管理中的事件id
                props: 
                  [
                      'data-page_name',
                      'data-page_url',
                      'data-channel',
                      'data-banner_type',
                      'data-banner_id',
                      'data-banner_name'
                  ], // 你要曝光的元素身上自定义属性
            },
            {
                // 需要曝光的元素class
                cssSelector: '.product-exp-component', 
                //如果页面模块是元素内滚动（某个区块内有滚动条）则需要增加positionSelector辅助定位曝光元素
                // positionSelector: '.parent', 
                logkey: 'ProductDetailPage_View',  //事件管理中的事件id
                props: [
                          'data-page_name',
                          'data-page_url',
                          'data-product_id',
                          'data-product_name',
                          'data-product_type',
                          'data-products_series'
                      ], // 你要曝光的元素身上自定义属性
              },
          ]
        ],
      });
    //自动曝光 页面浏览
    // aplus_queue.push({
    //     action: 'aplus.setMetaInfo',
    //     arguments: ['aplus-auto-exp', [
    //       {
    //           // 需要曝光的元素class
    //           cssSelector: '.banner-exp-component', 
    //           //如果页面模块是元素内滚动（某个区块内有滚动条）则需要增加positionSelector辅助定位曝光元素
    //           // positionSelector: '.parent', 
    //           logkey: 'Banner_Exposure',  //事件管理中的事件id
    //           props: 
    //             [
    //                 'data-page_name',
    //                 'data-page_url',
    //                 'data-channel',
    //                 'data-banner_type',
    //                 'data-banner_id',
    //                 'data-banner_name'
    //             ], // 你要曝光的元素身上自定义属性
    //         },
    //       ],'APPEND'
    //     ],
    //   });
}

export function isIos() {
    var u = navigator.userAgent; 
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端 
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return {
        isAndroid,
        isIOS,
    }
}


// WEBPACK FOOTER //
// ./src/util/utils.js